export const TIME_RANGE_ALL = 'ALL_TIME';

export const timeRangeOptions = [
  { value: TIME_RANGE_ALL, label: 'All time', days: 0 },
  { value: 'TODAY', label: 'Today', days: 0 },
  { value: 'LAST_24H', label: 'Last 24 hours', days: 1 },
  { value: 'LAST_7D', label: 'Last 7 days', days: 7 },
  { value: 'LAST_30D', label: 'Last 30 days', days: 30 },
  { value: 'LAST_90D', label: 'Last 90 days', days: 90 },
] as const;

export type TimeRangeValue = (typeof timeRangeOptions)[number]['value'];
